<template>
  <a-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="cancel" :loading="loading" @click="handleCancel">
        取消
      </a-button>
<!--      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">-->
<!--        确定-->
<!--      </a-button>-->
    </template>
    <a-descriptions>
      <a-descriptions-item
        v-for="(item, index) in acctCurList"
        :key="index"
        :label="item.key"
      >
        {{item.value}}
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>

<script>
// import { formItemLayout } from '@/config'

export default {
  name: 'Balance',
  props: {
    acctCurList: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    visible: false,
    loading: false,
    formItemLayout: Object.freeze({
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      }
    })
  }),
  created () {
  },
  methods: {
    handleCancel () {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/components/modal-form.less";
</style>
